const getters = {
  isUserLoggedIn(state) {
    return state.isUserLoggedIn
  },
  getUserAuthInfo(state) {
    return state.userAuthInfo
  },
  getAuthModalTab(state) {
    return state.authModalTab
  },
  getCategories(state) {
    return state.categories
  },
  getIsEmailVerified(state) {
    return state.isEmailVerified
  },
  getIsProfileActivated(state) {
    return state.isUserActivated
  },
  isAlertModalOpen(state) {
		return state.isAlertModalOpen
	},
	isLoginModalOpen(state) {
		return state.isLoginModalOpen
	},
	isLoginSelectionModalOpen(state) {
		return state.isLoginSelectionModalOpen
	},
	isSignupSelectionModalOpen(state) {
		return state.isSignupSelectionModalOpen
	},
	LoginSelectionMode(state) {
		return state.LoginSelectionMode
	},
  isForgetPasswordModalOpen(state) {
		return state.isForgetPasswordModalOpen
	}
}

export default getters
